import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import {
  isPaymentProofFileImage,
  isPaymentProofFilePdf,
} from '../../utils/paymentProofDisplay'

export default function PaymentProofFileViewer({
  fileUrl,
  title = 'Payment proof',
  maxHeight = '55vh',
}) {
  const url = String(fileUrl || '').trim()
  if (!url) {
    return (
      <Typography variant="body2" color="text.secondary">
        No file to display.
      </Typography>
    )
  }

  const isPdf = isPaymentProofFilePdf(url)
  const isImage = isPaymentProofFileImage(url) || (!isPdf && Boolean(url))

  return (
    <Box>
      {isPdf ? (
        <Box
          component="iframe"
          title={title}
          src={url}
          sx={{
            width: '100%',
            height: maxHeight,
            border: '1px solid #e5e7eb',
            borderRadius: 1,
            bgcolor: '#fff',
          }}
        />
      ) : isImage ? (
        <Box
          component="img"
          src={url}
          alt={title}
          sx={{
            width: '100%',
            maxHeight: maxHeight,
            objectFit: 'contain',
            bgcolor: '#111',
            borderRadius: 1,
          }}
        />
      ) : (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Preview not available for this file type.
        </Typography>
      )}
      <Button
        size="small"
        sx={{ mt: 1 }}
        component="a"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        Open file
      </Button>
    </Box>
  )
}
